import { markPriorityInboxThreadReadInCache } from "@circle-react/lib/queries/priorityInboxThreads";
import { isFunction } from "lodash";
import { useMutation } from "react-query";

import { reactQueryPatch } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

interface UseMarkChatRoomAsReadProps {
  onSuccess?: () => void;
}

export const useMarkChatRoomAsRead = ({
  onSuccess,
}: UseMarkChatRoomAsReadProps = {}) => {
  const { mutateAsync: markChatRoomAsRead } = useMutation({
    mutationFn: ({ uuid }: { uuid: string }) =>
      reactQueryPatch(
        internalApi.chatRooms.markAsRead({
          uuid,
        }),
      ),
    onSuccess: (_data, { uuid }) => {
      markPriorityInboxThreadReadInCache({ chatRoomUuid: uuid });
      isFunction(onSuccess) && onSuccess();
    },
    onError: (err: { message: string }) => {
      console.error(err.message);
    },
  });

  return { markChatRoomAsRead };
};
